import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

export const buildUserForm = (formBuilder: UntypedFormBuilder): UntypedFormGroup => {
  return formBuilder.group({
    username: ['', Validators.required],
    fullName: ['', Validators.required],
    sapId: ['', Validators.required],
  });
};
